import { render, staticRenderFns } from "./StickyMessage.vue?vue&type=template&id=467c1eb3&"
import script from "./StickyMessage.vue?vue&type=script&lang=js&"
export * from "./StickyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports